module.exports = __webpack_public_path__ + "img/气泡_1@2x.c79a29d7.png";